/** @format */

import { Col, Row, Grid } from "antd";
import { useTranslation } from "next-i18next";
import responsiveColumn from "../../../methods/responsiveColumn";
import parse from "html-react-parser";
import HomeForm from "../../components/home/HomeForm";

import BirdEyeWidget from "../BirdeyeWidget";

import type { FC } from "react";

interface LocationFormSectionProps {
  locationtypeData: any;
  location: string; // Add location as a prop
}

const LocationFormSection: FC<LocationFormSectionProps> = ({ locationtypeData, location }) => {
  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();
  const { t } = useTranslation("bankruptcy_section2");

  return (
    <>
      <Row
        justify={"center"}
        style={{
          paddingTop: 40,
          paddingBottom: 40,
          marginTop: 30,
          lineHeight: 1.5,
        }}
      >
        <Col span={23} className={"wide-content"}>
          <Row gutter={[50, 50]} justify={"center"}>
            <Col
              {...responsiveColumn([13, 11, 10, 23, 23, 23], [1, 1, 1, 2, 2, 2])}
              style={{ lineHeight: 1.5, fontSize: 16 }}
            >
              {parse(locationtypeData?.content?.rendered)}
            </Col>
            <Col {...responsiveColumn([9, 9, 10, 23, 23, 23], [2, 2, 2, 1, 1, 1])}>
              <HomeForm />
              <BirdEyeWidget />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default LocationFormSection;
